import React , { useEffect , useState } from "react";
import "./CvHeader.css";
import { fetchDataLeb } from "../../Service/data";
import { dataAllCv } from "../../AdminTools/AdminTools";

//export var Headeritems;

export const CvHeader = () =>{

    /*°_°*/ const [ rendItems , setItems ] = useState();

    useEffect(()=>{
        fetchData();
        toAdminToolFunc();
    },[]);


    const toAdminToolFunc = () =>{
        const sawwllksssaqseerwww2 = document.getElementById("sawwllksssaqseerwww2");
        sawwllksssaqseerwww2.addEventListener("click" , ()=>{
            const removeSectionCV = document.getElementsByClassName("removeSectionCV");
            setTimeout(() => {
                for (let i = 0; i < removeSectionCV.length; i++) {
                    removeSectionCV[i].addEventListener("click" , ()=>{
                        setTimeout(() => {
                            rendHeaderItems(dataAllCv.sec);
                        }, 250);
                    });
                }
            }, 250);



            setTimeout(() => {
                const moveIconsAtol = document.getElementsByClassName("moveIconsAtol");
                for (let i = 0; i < moveIconsAtol.length; i++) {
                    moveIconsAtol[i].addEventListener("click" , ()=>{
                        setTimeout(() => {
                            rendHeaderItems(dataAllCv.sec);
                        }, 250);
                    });
                }
            }, 200);



            setTimeout(() => {
                const AddNewSecHandelBtn = document.getElementById("AddNewSecHandelBtn");
                AddNewSecHandelBtn.addEventListener("click" , () =>{
                    setTimeout(() => {
                        rendHeaderItems(dataAllCv.sec);
                    }, 300);
                });
            }, 600);
        });
    }

    const HeaderItems = (event) =>{
        ///// get Cliced Item
        const HeaderItems = document.querySelectorAll(".HeaderItem");
        var clickedItem = 0;
        for (let i = 0; i < HeaderItems.length; i++) {
            if (event.target == HeaderItems[i]) {
                clickedItem = i;
            }else if (event.target.parentElement == HeaderItems[i]) {
                clickedItem = i;
            }
        }
        ///// to Transform
        const HeaderItemWidth = document.querySelectorAll(".HeaderItem")[0].getBoundingClientRect().width;
        let toTransform = HeaderItemWidth * clickedItem ;
        ///// transform stayle 
        const activeItem = document.getElementById("activeItem");
        activeItem.style.transformOrigin = "left 0";
        activeItem.style.transform = "translateX("+toTransform+"px)";
        ///// Active Label
        const IconHeaderItems = document.querySelectorAll(".IconHeaderItem");
        const LableHeaderItems = document.querySelectorAll(".LableHeaderItem");
        ///// Remove Style
        for (let k = 0; k < IconHeaderItems.length; k++) {
            IconHeaderItems[k].style.color = "rgb(1, 1, 107)";
            LableHeaderItems[k].style.color = "rgb(1, 1, 107)";
        }

        ///// Add Style
        const activeChildern = HeaderItems[clickedItem].children;
        for (let index = 0; index < activeChildern.length; index++) {
            activeChildern[index].style.color = "#007bff";
        }
        
    }

    window.addEventListener("DOMContentLoaded" , ()=>{
        ToScrollHeaderItems();
        window.addEventListener("resize" , ()=>{
            ToScrollHeaderItems();
        });
    });

    window.addEventListener("resize" , ()=> {
        custemstyle();
    })

    const custemstyle = () =>{
        const HeaderItems = document.querySelectorAll(".HeaderItem");
        // custem style
        const HeaderItemWidth = document.querySelectorAll(".HeaderItem")[0].getBoundingClientRect().width;
        const activeItem = document.querySelector("#activeItem");
        activeItem.style.width = HeaderItemWidth + "px";
        const IconHeaderItems = document.querySelectorAll(".IconHeaderItem");
        const LableHeaderItems = document.querySelectorAll(".LableHeaderItem");
        IconHeaderItems[0].style.color = "#007bff";
        LableHeaderItems[0].style.color = "#007bff";
    }

    const ToScrollHeaderItems = () =>{
        // Elements
        const HeaderItems = document.querySelectorAll(".HeaderItem");
        const CvHeader = document.querySelector("#CvHeader");
        const ToHeaderScroll = document.querySelector("#ToHeaderScroll");

        // info
        let widthOAll =  0;
        let HeaderWidth =  CvHeader.getBoundingClientRect().width;
        for (let i = 0; i < HeaderItems.length; i++) {
            widthOAll +=  HeaderItems[i].getBoundingClientRect().width;
        }
        if (widthOAll > HeaderWidth + 45 ) {
            ToHeaderScroll.classList.add("ToHeaderScrollActive");
        }else{
            ToHeaderScroll.classList.remove("ToHeaderScrollActive");
        }
    }

    const inScroll = () =>{
        const CvHeader = document.querySelector("#CvHeader");
        const setpWidth = document.querySelectorAll(".HeaderItem")[0].getBoundingClientRect().width;
        CvHeader.scrollBy({
            left: setpWidth ,
            top: 0,
            behavior: "smooth" ,
        });

    }

    const fetchData = async () =>{
        fetchDataLeb().then( data =>{
            rendHeaderItems(data.data.sec);
        })
    }

    const rendHeaderItems = (data) =>{
        const rend = data.map( (item , index) => 
            <div className="HeaderItem d-flex justify-content-center align-items-center" id={`cvhedite_${index}`}  onClick={HeaderItems} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut}>
                <i className={ item.head.logo + " IconHeaderItem"}></i> <span className="LableHeaderItem">{ item.head.title }</span>
            </div>
        );
        setItems(rend);
        custemstyle();
        


        setTimeout(() => {
            /***********************   Code From Ausbildung Component   *************************/
            // Elements
            const ItemofTimes = document.querySelectorAll(".Ausbildungs .ItemofTime");
            let HeaderItem = document.querySelectorAll(".HeaderItem ");
            // Last Item Remove Border border
            let lastItem = ItemofTimes.length - 1;
            ItemofTimes[lastItem].style.border = "none";
            // Last Item Remove Border border
            let lastItem2 = HeaderItem.length - 1;
            HeaderItem[lastItem2].style.border = "none";
            /***********************   Code From Ausbildung Component   *************************/
        }, 10);
        setTimeout(() => {
            /***********************   Code From Praktika Component   *************************/
            // Elements
            const ItemofTimes = document.querySelectorAll(".PraktikaBody .ItemofTime");
            // Last Item Remove Border border
            let lastItem = ItemofTimes.length - 1;
            ItemofTimes[lastItem].style.border = "none";
            /***********************   Code From Praktika Component   *************************/
        }, 30);
    }









    //_________________||" Admin Functions "||________________\\
    const hoverEditOn = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    const hoverEditOut = (event) => {
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }


















    











    return(
        <div className="bodymainContainerHeader">

            <div className="ToHeaderScroll d-flex align-items-center justify-content-center " id="ToHeaderScroll" onClick={inScroll}>
                <i class="fas fa-angle-right arrtoscIcon"></i>
            </div>

            <div className="CvHeader d-flex align-items-center" id="CvHeader">
                
                <div id="activeItem"><div className="InActive"></div></div>

                { rendItems }


                { /*  
                <div className="HeaderItem d-flex justify-content-center align-items-center" onClick={HeaderItems}>
                    <i className="fas fa-user IconHeaderItem"></i> <span className="LableHeaderItem">About</span>
                </div>

                <div className="HeaderItem d-flex justify-content-center align-items-center" onClick={HeaderItems}>
                    <i class="fas fa-briefcase IconHeaderItem"></i> <span className="LableHeaderItem">Ausbildung</span>
                </div>

                <div className="HeaderItem d-flex justify-content-center align-items-center" onClick={HeaderItems}>
                    <i class="fas fa-gavel IconHeaderItem"></i> <span className="LableHeaderItem">Praktika</span>
                </div>
                
                <div className="HeaderItem d-flex justify-content-center align-items-center" onClick={HeaderItems}>
                        <i class="fas fa-fill-drip IconHeaderItem"></i> <span className="LableHeaderItem">Kenntnisse</span>
                        
                </div>

                <div className="HeaderItem d-flex justify-content-center align-items-center" onClick={HeaderItems}>
                    <i class="fas fa-fill-drip IconHeaderItem"></i> <span className="LableHeaderItem">Kenntnisse</span>
                </div>

                */}

            </div>
        </div>
        );
}